/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';

export interface DeleteAccessRightProfile$Request {
    profileId: number;
}

export interface DeleteAccessRightProfile$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const deleteAccessRightProfileRequest = createAction<PayloadData<void, DeleteAccessRightProfile$Request>>('DELETE_ACCESS_RIGHT_PROFILE__DELETE_ACCESS_RIGHT_PROFILE__REQUEST');
export const deleteAccessRightProfileSuccess = createAction<PayloadData<void, DeleteAccessRightProfile$Request>>('DELETE_ACCESS_RIGHT_PROFILE__DELETE_ACCESS_RIGHT_PROFILE__SUCCESS');
export const deleteAccessRightProfileFailure = createAction<PayloadData<Error, DeleteAccessRightProfile$Request, true>>('DELETE_ACCESS_RIGHT_PROFILE__DELETE_ACCESS_RIGHT_PROFILE__FAILURE');

export const deleteAccessRightProfileActions = [
    deleteAccessRightProfileRequest,
    deleteAccessRightProfileSuccess,
    deleteAccessRightProfileFailure
] as const;

/**
 * @param {number} meta.profileId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const deleteAccessRightProfile = (meta: DeleteAccessRightProfile$Request, config?: DeleteAccessRightProfile$Config) => {
    return {
        CALL_API: {
            types: deleteAccessRightProfileActions,
            method: ApiMethods.DELETE,
            endpoint: `/web-api/admins/profiles/${meta.profileId}`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

